(function () {
  function initPlayers() {
    document.querySelectorAll('[data-ps-music]').forEach(function (wrapper) {
      if (wrapper.__ps_inited) return; // prevent double init
      wrapper.__ps_inited = true;

      const tracks = wrapper.querySelectorAll('[data-track]');
      let currentlyPlaying = null;

      function formatTime(seconds) {
        if (!seconds || isNaN(seconds)) return '0:00';
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return m + ':' + (s < 10 ? '0' : '') + s;
      }

      function stopAudio(audioEl) {
        if (!audioEl) return;
        audioEl.pause();
        audioEl.currentTime = 0;

        const track = audioEl.closest('[data-track]');
        if (!track) return;

        const btn = track.querySelector('[data-play]');
        const fill = track.querySelector('[data-fill]');
        const currentEl = track.querySelector('[data-current]');

        if (btn) btn.classList.remove('is-playing');
        if (fill) fill.style.width = '0%';
        if (currentEl) currentEl.textContent = '0:00';
      }

      tracks.forEach(function (track) {
        const audio = track.querySelector('audio[data-audio]');
        const source = audio ? audio.querySelector('source') : null;
        const btn = track.querySelector('[data-play]');
        const bar = track.querySelector('[data-bar]');
        const fill = track.querySelector('[data-fill]');
        const currentEl = track.querySelector('[data-current]');
        const durationEl = track.querySelector('[data-duration]');

        if (!audio || !btn || !bar || !fill || !currentEl || !durationEl) return;

        function hasMp3() {
          return !!(source && (source.getAttribute('src') || '').trim());
        }

        // Ensure duration shows
        audio.addEventListener('loadedmetadata', function () {
          durationEl.textContent = formatTime(audio.duration);
        });

        btn.addEventListener('click', function () {
          if (!hasMp3()) return;

          // stop other track
          if (currentlyPlaying && currentlyPlaying !== audio) {
            stopAudio(currentlyPlaying);
            currentlyPlaying = null;
          }

          if (audio.paused) {
            audio.play().then(function () {
              btn.classList.add('is-playing');
              currentlyPlaying = audio;
            }).catch(function (e) {
              console.log('Audio play blocked:', e);
            });
          } else {
            audio.pause();
            btn.classList.remove('is-playing');
            currentlyPlaying = null;
          }
        });

        audio.addEventListener('timeupdate', function () {
          const pct = (audio.currentTime / audio.duration) * 100;
          fill.style.width = (pct || 0) + '%';
          currentEl.textContent = formatTime(audio.currentTime);
        });

        audio.addEventListener('ended', function () {
          btn.classList.remove('is-playing');
          audio.currentTime = 0;
          fill.style.width = '0%';
          currentEl.textContent = '0:00';
          currentlyPlaying = null;
        });

        bar.addEventListener('click', function (e) {
          if (!hasMp3() || !audio.duration) return;
          const rect = bar.getBoundingClientRect();
          const pct = (e.clientX - rect.left) / rect.width;
          audio.currentTime = Math.max(0, Math.min(1, pct)) * audio.duration;
        });
      });
    });
  }

  // Run now + retry (Shopify sections can render after DOMContentLoaded)
  document.addEventListener('DOMContentLoaded', initPlayers);
  window.addEventListener('load', initPlayers);
  setTimeout(initPlayers, 500);
  setTimeout(initPlayers, 1500);
})();
